import React, { useMemo } from 'react';
import DatePicker from 'react-datepicker';
import dayjs from 'dayjs';

import {  DATEPICKER_DATE_FORMAT } from '../../../utils/constants';

import css from '../input/input.module.scss';
import 'react-datepicker/dist/react-datepicker.css';

interface DatePickerInputProps {
	error?: string;
	label?: string;
	maxDate?: Date;
	minDate?: Date;
	placeholderText?: string;
	date?: Date;
	onDateChange: (date: Date) => void;
}

const DatePickerInput: React.FC<DatePickerInputProps> = (props) => {
	const className = useMemo((): string => {
		let defaultClass: string = css['form-input-group-container'];
		if (props.error) defaultClass += ` ${css['form-input-group-invalid']}`;

		return defaultClass;
	}, [props.error]);

	return (
		<div className={css['form-input-group']}>
			{props.label && <label>{props.label}:</label>}

			<div>
				<DatePicker
					dateFormat={DATEPICKER_DATE_FORMAT}
					minDate={props.minDate}
					selected={dayjs(props.date).isValid() ? dayjs(props.date).toDate() : null}
					onChange={props.onDateChange}
					maxDate={props.maxDate}
					placeholderText={props.placeholderText}
					className={className}
				/>
			</div>

			{props.error && <div className="error">{props.error}</div>}
		</div>
	);
};

export default DatePickerInput;
